import React, { useRef } from 'react';
import { MDBLoadingManagement } from 'mdb-react-ui-kit';

const LoadingOverlay = () => {
    const basicRef = useRef(null);

    return (
        <div ref={basicRef} className='loader-style'>
            <MDBLoadingManagement parentRef={basicRef} backdropOpacity={0.2} fullScreen />
        </div>
    );
}

export default LoadingOverlay;
